// extracted by mini-css-extract-plugin
module.exports = {"fieldCaption":"fieldCaption_c5xj5"};